const reducer = (state = 'All', action) =>{
    switch(action.type){
        case "setWorkflowEligible": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  